export default __webpack_public_path__ + "static/media/color_6.73728eb0.png";